import { Columns } from '@shared/interfaces/table/column-config';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';

export const statePartial: Columns<any> ={
  title: 'connectionpoint.status',
  key: 'state',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    notspecified: {color: 'bg-grey-500', label: 'status.unknown'},
    active: {color: 'bg-green-500', label: 'status.active'},
    inactive: {color: 'bg-red-500', label: 'status.inactive'},
  }
}
